import { PERSONAL_TITLES } from '../../../utils/util.constants';
import isUndefined from 'lodash/isUndefined';
import get from 'lodash/get';

class SelectPersonalTitleController {
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
        this.options = PERSONAL_TITLES;
    }

    $onInit() {
        if (isUndefined(this.validate))
            this.validate = false;

        if (this.validate && isUndefined(this.name))
            throw new Error('Missing select name attribute');

        this.unsubscribeModule = this.$ngRedux.connect(this.mapModule, {})(this);
        this.unsubscribe = this.$ngRedux.connect(this.mapState.bind(this), {})(this);
    }

    onSelect() {
        if (this.selectedOption) {
            this.$ngRedux.dispatch({
                type: 'PERSONAL_TITLE_SELECTED',
                id: this.identifier,
                title: this.selectedOption,
                path: this.statePath
            });
        }
    }

    $onDestroy() {
        this.unsubscribe();
        this.unsubscribeModule();
    }

    mapModule(state) {
        return {
            module: state.navigation.module
        };
    }

    mapState(state) {
        return {
            selectedOption: get(state[this.module][this.identifier], this.statePath)
        };
    }
}

SelectPersonalTitleController.$inject = ['$ngRedux'];

export const selectPersonalTitle = {
    bindings: {
        identifier: '@',
        name: '@',
        statePath: '@',
        validate: '<',
        required: '<'
    },
    require : {
        form : '^form'
    },
    controller: SelectPersonalTitleController,
    template: `
        <md-input-container class="md-block" flex>
            <label>Title</label>
            <md-select id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-model="$ctrl.selectedOption" md-on-close="$ctrl.onSelect()" ng-required="$ctrl.required">
                <md-option ng-value="item.id" ng-repeat="item in $ctrl.options">
                    <span class="md-body-2">{{item.title}}</span>
                </md-option>
            </md-select>
    
            <div ng-messages="$ctrl.form[$ctrl.name].$error">
                <div ng-message="required">{{'COMMON.FIELD_REQUIRED' | translate}}</div>
            </div>
        </md-input-container>
    `
};
